module.exports = __webpack_public_path__ + "static/img/hysteroscope-detail-3.9e98762.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-detail-3.jpg
// module id = ZAkF
// module chunks = 51